import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import {
  GetProvinces,
  GetCitys,
  GetAreas,
  GetAgentList,
  GetParmConfig, //寄送，支付接口
  GetProductClass,
  GetAgentConsigneeList,
  Consignee_Add,
  GetEmployList,
  ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗

export default {
  mixins: [services],
  components: {
    chooseDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      AddDialogVisible: false,
      agent: '',
      school: '',
      title: '',
      minNum: 1,
      form: this.getSubmitFormData(),
      auditFormData: this.getAuditData(),
      SendLessonReasons: [{
        id: 1,
        name: '公司原因影响课程补偿'
      }, {
        id: 2,
        name: '配合园所活动'
      }, {
        id: 3,
        name: '按时续/扩班'
      }, {
        id: 4,
        name: ' 提前续班'
      }, {
        id: 5,
        name: '提前扩班（3个及以上班级）'
      }, {
        id: 6,
        name: 'Hi-E设备体验课'
      }, {
        id: 7,
        name: 'OA特殊申请'
      }],
      Projects: [{
        id: 1,
        name: '联帮在线'
      }, {
        id: 2,
        name: 'HI幼教'
      }, {
        id: 4,
        name: '智趣坞'
      }],
      storageData: '',
      ClassNum: 1,
      status: [{
        "name": "审核通过",
        "id": "6"
      }, {
        "name": "审核不通过",
        "id": "11"
      }]
    }
  },
  methods: {
    getSubmitFormData() {
      return cloneDeep({
        "AgentId": 0,
        "SchoolId": 0,
        "ClassNum": 0,
        "SendLessonReason": "",
        "SendLessonRemark": "",
        "OACode": "",
        "VirtualList": [{
          "ProId": '',
          "ProNum": '',
          "ProBrand": '',
          "minNum": 0,
          "maxNum": Infinity,
          "LessonTypes": []
        }],
      });
    },
    getAuditData() {
      return cloneDeep({
        OrderId: '',
        OrderStatus: '',
        AuditRemark: ""
      });
    },
    // 获取组件chooseDialog 值
    getDialogList(item) {
      if (item.title == '选择代理商') {
        this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
        this.form.AgentId = item.Id,
          this.school = '',
          this.form.SchoolId = 0
      } else {
        this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
        this.form.SchoolId = item.Id
      }


    },
    // 选择代理商
    chooseAgent() {
      this.$refs.chooseDialog.show({
        title: '选择代理商',
        isCommon: true
      });

    },
    // 新增其他赠课
    addOtherLesson() {
      this.form.VirtualList.push({
        "ProId": '',
        "ProNum": '',
        "ProBrand": '',
        "minNum": 1,
        "maxNum": Infinity,
        "LessonTypes": []
      })
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    //选择园所
    chooseSchool() {
      if (this.form.AgentId == 0) {
        this.$notify({
          title: '警告',
          message: '请先选择代理商',
          type: 'warning'
        });
      } else {
        this.$refs.chooseDialog.show({
          title: '选择园所',
          AgentId: this.form.AgentId,

        });

      }

    },
    //初始化数据
    initData() {
      this.agent = ''
      this.school = ''
      this.loading = false
      this.auditFormData = this.getAuditData()
      this.form = this.getSubmitFormData()
      this.storageData = ""
    },
    show(options) {
      this.initData();
      this.AddDialogVisible = true
      this.title = options.title
      if (options.OrderId) {
        this.form.OrderId = options.OrderId
        this.getList(options.OrderId)
      }

    },
    // 选择赠课原因
    changeSendLessonReason(val) {
      if (val !== this.storageData) {
        // 切换
        this.ClassNum = 1
        this.form.VirtualList = [{
          "ProId": '',
          "ProNum": '',
          "ProBrand": '',
          "minNum": 1,
          "maxNum": this.maxNum,
          "LessonTypes": []
        }]
      }

    },
    // 选择项目类型
    changeProject(val) {
      // if (this.LessonTypes.length == 0) {
      //   this.$notify({
      //     title: '警告',
      //     message: '请先选择送课原因',
      //     type: 'warning'
      //   });
      // }
    },
    // 选择课程类型
    changeLessonType(val) {
      // if (this.LessonTypes.length == 0 && val) {
      //   this.$notify({
      //     title: '警告',
      //     message: '请先选择送课原因',
      //     type: 'warning'
      //   });
      // }
    },
    changeValueP(index) {
      console.log('here')
      let obj = this.form.VirtualList
      if (this.storageData === '') {
        if (obj[index].ProBrand === 1) {
          // 联帮在线
          if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 6) {
            // new
            obj[index].LessonTypes = [{
              id: 750,
              name: "体验课"
            }]
            this.form.VirtualList[0].ProId = 750
          } else if (this.form.SendLessonReason == 2) {

            obj[index].LessonTypes = [{
              id: 752,
              name: "公开课"
            }, {
              id: 756,
              name: "中教课"
            }]


          } else if (this.form.SendLessonReason == 7) {
            // OA特殊申请  new
            obj[index].LessonTypes = [{
              id: 759,
              name: "D体验课"
            }, {
              id: 752,
              name: "公开课"
            }, {
              id: 757,
              name: "正式课"
            }]


          } else if (this.form.SendLessonReason > 2 && this.form.SendLessonReason !== 7) {
            obj[index].LessonTypes = [{
              id: 754,
              name: "寒暑班"
            }]
            this.form.VirtualList[0].ProId = 754
          }
        } else if (obj[index].ProBrand > 1) {
          // hi幼教  智趣坞
          if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 6) {
            // new
            obj[index].LessonTypes = [{
              id: 750,
              name: "体验课赠课"
            }, {
              id: 759,
              name: "D体验课"
            }]
            this.form.VirtualList[0].ProId = 750
          } else if (this.form.SendLessonReason == 2) {

            obj[index].LessonTypes = [{
              id: 752,
              name: "公开课"
            }, {
              id: 756,
              name: "中教课"
            }]
          } else if (this.form.SendLessonReason == 7) {
            // OA特殊申请  new
            obj[index].LessonTypes = [{
              id: 750,
              name: "体验课赠课"
            }, {
              id: 759,
              name: "D体验课"
            }, {
              id: 752,
              name: "公开课"
            }, {
              id: 757,
              name: "正式课"
            }]
          } else if (this.form.SendLessonReason > 2 && this.form.SendLessonReason !== 7) {
            obj[index].LessonTypes = [{
              id: 754,
              name: "寒暑班"
            }]
            this.form.VirtualList[0].ProId = 754
          }
        }
      }
    },
    changeValue(index) {
      let obj = this.form.VirtualList
      if (index >= 1) {
        if (obj[index].ProId == obj[index - 1].ProId || (index >= 2 && obj[index].ProId == obj[index - 2].ProId)) {
          this.$notify({
            title: '警告',
            message: '不能选择一样的课程类型',
            type: 'warning'
          });
          obj[index].ProId = ''
        }
      }
      if (this.form.SendLessonReason == 7 && this.storageData == '') {
        if (obj[index].ProId == 759) {
          obj[index].minNum = 4
          obj[index].ProNum = 4
          obj[index].maxNum = Infinity
        } else if (obj[index].ProId == 757) {
          obj[index].minNum = 16
          obj[index].ProNum = 16
          obj[index].maxNum = 32
        } else {
          obj[index].minNum = 1
          obj[index].ProNum = 1
          obj[index].maxNum = Infinity
        }
      }

    },
    submit() {
      // 新增
      let rule = [{
        name: "代理商",
        value: this.agent,
        required: true,
        msg: '请选择代理商'
      }, {
        name: "园所",
        value: this.school,
        required: true,
        msg: '请选择园所'
      }, {
        name: "送课原因",
        value: this.form.SendLessonReason,
        required: true,
        msg: '请选择送课原因'
      }, ];

      let num = 0

      for (let i = 0; i < this.form.VirtualList.length; i++) {
        rule.push({
          name: "赠送课程项目",
          value: this.form.VirtualList[i].ProBrand,
          required: true,
          msg: '请选择课程项目'
        }, {
          name: "赠送课程类型",
          value: this.form.VirtualList[i].ProId,
          required: true,
          msg: '请选择送课类型'
        })
        num += this.form.VirtualList[i].ProNum
      }
      rule.push({
        name: "详细说明赠课原因",
        value: this.form.SendLessonRemark,
        required: true,
      })
      if (num > 3 && this.form.SendLessonReason == 2) {
        this.$notify({
          title: '警告',
          message: '赠送课时数累计不能超过3',
          type: 'warning'
        });
        return;
      }
      if (this.form.VirtualList[0].ProNum < 8) {
        this.form.ClassNum = 0
      }
      // 班级数不能大于赠送课时数
      if (this.form.ClassNum > num) {
        this.$notify({
          title: '警告',
          message: '上课班级数不能大于赠送课时数',
          type: 'warning'
        });
        return;
      }
      if (this.form.SendLessonReason == 7 && this.form.OACode == "") {
        this.$notify({
          title: '警告',
          message: '请填写OA工作流编号',
          type: 'warning'
        });
        return;
      } else if (this.form.SendLessonReason !== 7) {
        this.form.OACode == ""
      }
      var flag = util.checkForm({
        ele: this,
        rules: rule
      });

      if (!flag) {
        return;
      }
      if (this.form.OrderId) {
        this.SendLessonOrderUpdate()
      } else {
        this.SendLessonOrderAdd()
      }


    }
  },
  computed: {
    maxNum() {
      if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 2) {
        return 3
      } else if (this.form.SendLessonReason == 3) {
        return 8
      } else if (this.form.SendLessonReason == 4) {
        return 16
      } else if (this.form.SendLessonReason == 5) {
        return 32
      } else if (this.form.SendLessonReason == 6) {
        this.form.VirtualList[0].ProNum = 16
        return 16
      } else {
        return Infinity
      }
    },
    // minNum() {
    //   if (this.form.SendLessonReason == 7) {
    //     return 4
    //   } else {
    //     return 1
    //   }
    // },
    isShowClassNum() {
      let num = this.form.VirtualList[0].ProNum
      if (num >= 8) {
        this.form.ClassNum = this.ClassNum
        return true
      } else {
        return false
      }
    },
    showAddBtn() {
      if (this.form.SendLessonReason == 2 && this.form.VirtualList.length < 2) {
        return true
      } else if (this.form.SendLessonReason == 7 && this.form.VirtualList.length < 3) {
        return true
      } else if (this.form.SendLessonReason == 2 && this.form.VirtualList.length > 2) {
        return false
      } else if (this.form.SendLessonReason == 7 && this.form.VirtualList.length > 3) {
        return false
      } else {
        return false
      }
    },

    // 课程类型
    // LessonTypes() {
    //   console.log(this.form.VirtualList)
    //   let arr = []
    //   if (this.form.SendLessonReason == 1 || this.form.SendLessonReason == 6) {
    //     arr = [{
    //       id: 750,
    //       name: "体验课"
    //     }]
    //     this.form.VirtualList[0].ProId = 750
    //   } else if (this.form.SendLessonReason == 2) {

    //     arr = [{
    //       id: 752,
    //       name: "公开课"
    //     }, {
    //       id: 756,
    //       name: "中教课"
    //     }]


    //   } else if (this.form.SendLessonReason == 7) {
    //     // OA特殊申请
    //     arr = [{
    //       id: 759,
    //       name: "D体验课"
    //     }, {
    //       id: 752,
    //       name: "公开课"
    //     }, {
    //       id: 757,
    //       name: "正式课"
    //     }]


    //   } else if (this.form.SendLessonReason > 2 && this.form.SendLessonReason !== 7) {
    //     arr = [{
    //       id: 754,
    //       name: "寒暑班"
    //     }]
    //     this.form.VirtualList[0].ProId = 754
    //   }
    //   return arr
    // }
  },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addSendLessonDialog/vm.js